/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { Configuration } from '../configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiFilesFileIdExistsGet } from '../fn/files/api-files-file-id-exists-get';
import { ApiFilesFileIdExistsGet$Params } from '../fn/files/api-files-file-id-exists-get';
import { apiFilesGenerateUploadUrlPost } from '../fn/files/api-files-generate-upload-url-post';
import { ApiFilesGenerateUploadUrlPost$Params } from '../fn/files/api-files-generate-upload-url-post';
import { CheckFileExistsResult } from '../models/check-file-exists-result';
import { GenerateFileUploadUrlResult } from '../models/generate-file-upload-url-result';


/**
 * File management
 */
@Injectable({ providedIn: 'root' })
export class FilesService extends BaseService {
  constructor(config: Configuration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiFilesGenerateUploadUrlPost()` */
  static readonly ApiFilesGenerateUploadUrlPostPath = '/api/files/generate-upload-url';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiFilesGenerateUploadUrlPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiFilesGenerateUploadUrlPost$Response(params?: ApiFilesGenerateUploadUrlPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GenerateFileUploadUrlResult>> {
    const obs = apiFilesGenerateUploadUrlPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiFilesGenerateUploadUrlPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiFilesGenerateUploadUrlPost(params?: ApiFilesGenerateUploadUrlPost$Params, context?: HttpContext): Observable<GenerateFileUploadUrlResult> {
    const resp = this.apiFilesGenerateUploadUrlPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GenerateFileUploadUrlResult>): GenerateFileUploadUrlResult => r.body)
    );
  }

  /** Path part for operation `apiFilesFileIdExistsGet()` */
  static readonly ApiFilesFileIdExistsGetPath = '/api/files/{fileId}/exists';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiFilesFileIdExistsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiFilesFileIdExistsGet$Response(params: ApiFilesFileIdExistsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CheckFileExistsResult>> {
    const obs = apiFilesFileIdExistsGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiFilesFileIdExistsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiFilesFileIdExistsGet(params: ApiFilesFileIdExistsGet$Params, context?: HttpContext): Observable<CheckFileExistsResult> {
    const resp = this.apiFilesFileIdExistsGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CheckFileExistsResult>): CheckFileExistsResult => r.body)
    );
  }

}
